import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/student-dashboard.css';

// Professional SVG Icons
const Icons = {
  home: <svg className="gm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>,
  plane: <svg className="gm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path></svg>,
  calendar: <svg className="gm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
  building: <svg className="gm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18"></path><path d="M5 21V7l7-4 7 4v14"></path><path d="M9 9h0M9 13h0M9 17h0M15 9h0M15 13h0M15 17h0"></path></svg>,
  arrowLeft: <svg className="gm-icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>,
  chevronRight: <svg className="gm-icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>,
};

const GatepassMenu = () => {
  const navigate = useNavigate();

  return (
    <div className="sd-shell">
      {/* Header */}
      <header className="sd-header">
        <div className="sd-header-brand">
          <span className="sd-logo">GoThru</span>
        </div>
        <button
          className="sa-back-btn"
          onClick={() => navigate('/student')}
        >
          {Icons.arrowLeft} Back
        </button>
      </header>

      <main className="sd-main gm-main">
        <h1 className="gm-title">Apply for Gatepass</h1>
        <p className="gm-subtitle">Select the type of gatepass you need</p>

        <div className="gm-options">
          {/* Local Gatepass Card */}
          <div className="gm-card" onClick={() => navigate('/student/gatepass/local')}>
            <div className="gm-card-icon">{Icons.home}</div>
            <div className="gm-card-content">
              <h3 className="gm-card-title">Local Gatepass</h3>
              <p className="gm-card-desc">For short trips within the city. Valid for same day return.</p>
            </div>
            <div className="gm-card-arrow">{Icons.chevronRight}</div>
          </div>

          {/* Outstation Gatepass Card */}
          <div className="gm-card" onClick={() => navigate('/student/gatepass/outstation')}>
            <div className="gm-card-icon">{Icons.plane}</div>
            <div className="gm-card-content">
              <h3 className="gm-card-title">Outstation Gatepass</h3>
              <p className="gm-card-desc">For trips outside the city.</p>
            </div>
            <div className="gm-card-arrow">{Icons.chevronRight}</div>
          </div>

          {/* Mid Sem / End Sem Break Card */}
          <div className="gm-card" onClick={() => navigate('/student/gatepass/midsem-break')}>
            <div className="gm-card-icon">{Icons.calendar}</div>
            <div className="gm-card-content">
              <h3 className="gm-card-title">Mid Sem / End Sem Break</h3>
              <p className="gm-card-desc">For semester breaks. Goes directly to hostel office for approval.</p>
            </div>
            <div className="gm-card-arrow">{Icons.chevronRight}</div>
          </div>

          {/* Bangalore (3rd year transfer) Card */}
          <div className="gm-card" onClick={() => navigate('/student/gatepass/bangalore')}>
            <div className="gm-card-icon">{Icons.building}</div>
            <div className="gm-card-content">
              <h3 className="gm-card-title">Bangalore Campus Transfer</h3>
              <p className="gm-card-desc">This is only for 3rd year students moving permanently for Bangalore campus RGIPT.</p>
            </div>
            <div className="gm-card-arrow">{Icons.chevronRight}</div>
          </div>
        </div>

        <div className="gm-note">
          <strong>Note:</strong> All gatepasses require hostel office approval before they can be used for exit.
        </div>
      </main>

      {/* Footer */}
      <div className="sd-footer">
        GoThru v1.1 • RGIPT Campus Access System
      </div>
    </div>
  );
};

export default GatepassMenu;
